import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LanguagePickerService {
    private supportedLanguages = ["English", "Deutsch"];
    currentLanguage$: BehaviorSubject<string>;

    constructor(private translateService: TranslateService) {
        
        if(environment.defaultLocale === 'en') {
            this.currentLanguage$ = new BehaviorSubject(this.supportedLanguages[0]);
        } else {
            this.currentLanguage$ = new BehaviorSubject(this.supportedLanguages[1]);
        }
    }

    public getSupportedLanguages(): Array<string> {
        return this.supportedLanguages;
    }

    public changeLanguage(language: string): void {
        if(language !== this.currentLanguage$.getValue()) {
            if(language === this.supportedLanguages[0]) {
                this.translateService.use("en");
            } else {
                this.translateService.use("de");
            }
            this.currentLanguage$.next(language);
        }
    }

    public getLanguage(): BehaviorSubject<string> {
        return this.currentLanguage$;
    }

    public getLanguageCode(): string {
        let code;
        this.currentLanguage$.subscribe(language => (language === 'English') ? code = 'en' : code = 'de');
        return code;
    }

    public isEnglish(): boolean {
        return this.getLanguageCode() === 'en';
    }
}
